// @flow

import type {
  AssetsById,
} from 'fc-model-assets/types'

// Libs
import { createSelector } from 'reselect'

// Utils
import buildChildrenIndex from '../utils/buildChildrenIndex'

// Selectors
import assets$ from './assets'

// Exports
export default (createSelector(
  [assets$],
  function (assets: AssetsById): {[number]: Array<number>} {
    return buildChildrenIndex(assets)
  }
): Selector$<{[number]: Array<number>}>)
